import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import HeroSection from './components/HeroSection';
import CategoryNavSection from './components/CategoryNavSection';
import HotAlbumsSection from './components/HotAlbumsSection';
import LatestArticlesSection from './components/LatestArticlesSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = t('seo.homeTitle');
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) metaDesc.setAttribute('content', t('seo.homeDesc'));
    const metaKw = document.querySelector('meta[name="keywords"]');
    if (metaKw) metaKw.setAttribute('content', t('seo.homeKeywords'));
  }, [t]);

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'mm131写真图库',
    url: 'https://www.mm131.com',
    description: t('seo.homeDesc'),
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: 'https://www.mm131.com/search?q={search_term_string}',
      },
      'query-input': 'required name=search_term_string',
    },
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'mm131写真图库',
    url: 'https://www.mm131.com',
    description: t('seo.homeDesc'),
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '400-888-1314',
      contactType: 'customer service',
      availableLanguage: ['Chinese'],
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>
      <article>
        <HeroSection />
        <CategoryNavSection />
        <HotAlbumsSection />
        <LatestArticlesSection />
        <FAQSection />
        <CTASection />
      </article>
    </>
  );
}